import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Logger } from 'fsts';

const logger = new Logger('filter-dialog');
const contactModule = namespace('contact');

@Component({
  name: 'filter-dialog',
})
export default class FilterDialog extends Vue {
  @Ref('observer-filter-dialog-form')
  private observerFilterDialogForm!: any;

  @contactModule.Action('getContacts')
  private actionGetContacts!: any;

  @contactModule.Action('updateSearchData')
  private actionUpdateSearchData!: any;
  @contactModule.Getter('getSearchData')
  private searchData!: any;

  @Prop({ default: false })
  private dialog!: boolean;

  isSaving = false;
  activeState = [
    {
      text: this.$i18n.t(`employee_status_select.all`), //'Alle',
      value: null,
    },
    {
      text: this.$i18n.t(`employee_status_select.active`), //'Ja',
      value: true,
    },
    {
      text: this.$i18n.t(`employee_status_select.inactive`), //'Nein',
      value: false,
    },
  ];

  filter() {
    this.actionUpdateSearchData(this.searchData)
      .then(() => {
        this.clickClose();
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  clickClose() {
    this.$emit('click:close');
  }
}
